import { useEffect, useState, useCallback } from "react";
import { fetchWeeklyDashboardApi } from "../services/dashboardService";
import useStore from "../utils/store";

export function useDashboard({ workspaceId, start, end, token }) {
  const [data, setData] = useState({});
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const dashboardRefreshTrigger = useStore(state => state.dashboardRefreshTrigger);
  const triggerDashboardRefresh = useStore(state => state.triggerDashboardRefresh);

  const fetchDashboard = useCallback(async () => {
    if (!workspaceId || !start || !end) return;
    setLoading(true);
    setError("");
    try {
      const result = await fetchWeeklyDashboardApi({ workspaceId, start, end, token });
      setData(result);
    } catch (err) {
      console.error(err);
      setError("Failed to load dashboard data.");
    } finally {
      setLoading(false);
    }
  }, [workspaceId, start, end, token]);

  useEffect(() => {
    fetchDashboard();
  }, [fetchDashboard, dashboardRefreshTrigger]);

  return { data, loading, error, reload: triggerDashboardRefresh };
}
